"use client";

import { ChatHeader } from "@/components/chat-header";
import { UpdatesBoard } from "@/components/updates/UpdatesBoard";

export default function UpdatesPage() {
  return (
    <div className="min-h-screen bg-[#09090b]">
      <ChatHeader
        chatId=""
        selectedVisibilityType="public"
        isReadonly={false}
        section="chat"
        title="Changelog"
      />
      <UpdatesBoard />
    </div>
  );
}
